<template>
    <div>
        <!-- <div class="pop_open" @click="showModal">
            <div class="info_icon">
                <SvgHeaderSvg :type="'ask'" />
            </div>
        </div> -->

        <div >
            <Teleport  to="#teleports">
                <div class="modal fade" data-bs-backdrop="true" :id="`modal-${ringBox}`"  tabindex="-1" aria-labelledby="exampleModalLabel"
                aria-hidden="true">
                    <div class="modal-dialog">
                        <div class="modal-content">                     
                            <div class="modal-body">
                                <div class="title_block">
                                    <!-- <h3 class="mb-0 font-active" v-if="item === ''">Diamond Spread : N/A</h3> -->
                                    <h3 class="mb-0 font-active" >{{ title }} :  <span>{{item.diamond_spread}}%</span></h3>
                                    <span @click="notOpenModal"><SvgHeaderSvg type="close" class="largesvg"/></span>
                                </div>
                                <div class="mt-3">
                                    <!-- <p class="mb-0" v-if="item === ''">Diamond spread on a ring setting refers to the arrangement and distribution of smaller diamonds across the band or around a center stone. This enhances the overall sparkle and appearance of the ring.</p> -->
                                    <p>Diamond spread refers to the percentage of the shank that is covered with diamonds. Diamond spread is usually 50%, 75%, or 100%. The spread can enhance the overall sparkle and appearance of the ring.</p>

                                    <div class="image_block my-2 text-center">
                                        <div @click="setActive('50')" :class="{ active: activeSpread === '50' }">
                                          <img width="150" height="72" v-show="activeSpread !== '50'" src="~/assets/presetdetails/fifty.svg" alt="diamond spread" />
                                          <img width="150" height="72" v-show="activeSpread === '50'" src="/settingactive/fifty.svg" alt="diamond spread" />
                                          <p :class="{ 'inactive': activeSpread !== '50', active: activeSpread === '50' }">50%</p>
                                        </div>
                                      
                                        <div @click="setActive('75')" :class="{ active: activeSpread === '75' }">
                                          <img width="150" height="72" v-show="activeSpread !== '75'" src="~/assets/presetdetails/seventyfive.svg" alt="diamond spread" />
                                          <img width="150" height="72" v-show="activeSpread === '75'" src="/settingactive/seventyfive.svg" alt="diamond spread" />
                                          <p :class="{ 'inactive': activeSpread !== '75', active: activeSpread === '75' }">75%</p>
                                        </div>
                                      
                                        <div @click="setActive('100')" :class="{ active: activeSpread === '100' }">
                                          <img width="150" height="72" v-show="activeSpread !== '100'" src="~/assets/presetdetails/hundred.svg" alt="diamond spread" />
                                          <img width="150" height="72" v-show="activeSpread === '100'" src="/settingactive/hundred.svg" alt="diamond spread" />
                                          <p :class="{ 'inactive': activeSpread !== '100', active: activeSpread === '100' }">100%</p>
                                        </div>
                                    </div>
                                      

                                    <p class="mb-0" v-if="activeSpread === '50'" >Half of the shank features diamonds, providing a balance between diamond presence and metal visibility.</p>
                                    <p class="mb-0" v-if="activeSpread === '75'">With diamonds covering three-quarters of the shank, this design delivers an impressive sparkle while preserving a touch of metal for contrast.</p>
                                    <p class="mb-0" v-if="activeSpread === '100'">The entire shank is covered with diamonds, offering maximum sparkle and brilliance.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Teleport>
        </div>
     
    </div>
   
</template>

<script setup>
    const flagShowModal = ref(false);
    const diamondRef = ref(null);
    const props = defineProps(['item','title','ringBox'])

    const active = ref(props.ringBox)
    const notOpenModal = () => {
        emit('close');
        active.value = null;
    };
    const emit = defineEmits(['close']);

    const showModal = () => {
        flagShowModal.value = true;
        nextTick(() => {
        const modalElement = diamondRef.value;
        if (modalElement) {
        const modalInstance = new bootstrap.Modal(modalElement);
        modalInstance.show();
        }
        });
    };

    const hideModal = () => {
        const modalElement = diamondRef.value;
        if (modalElement) {
            const modalInstance = bootstrap.Modal.getInstance(modalElement);
            if (modalInstance) {
                modalInstance.hide();
            }
        }
        flagShowModal.value = false;
    };

    const activeSpread = ref(props.item.diamond_spread)
    watch(() => props.item.diamond_spread, (newValue) => {
        activeSpread.value = newValue;
   
    });

    const setActive = (spread) => {
        nextTick(() => {
        activeSpread.value = spread;
    });

    };
</script>



<style scoped>
 .largesvg {
    transform: scale(1.3);
    }
.pop_open{
    color: #cccccc;
    font-size: 14px;
    cursor: pointer;
}

.title_block{
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.title_block span {
    cursor: pointer;
    color: var(--green);
}

h3 {
    font-size: 22px;
}


p {
    font-size: 16px;
    color: #606060;
}

.m-info {
    margin: 10px 0;
}
.image_block{
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
}
.image_block p{
    font-size: 16px;
    color: #668b84;
    font-weight: 600;
    text-decoration: underline;
}
.image_block .inactive {
    color: #909090;
  }

@media(max-width: 767px){
    h3 {
        font-size: 20px;
    }
    p {
        font-size: 14px;
    }

}
</style>
